// ?-----------------------------------------------------------------
// ? PRODUCT PAGE FUNCTIONS
// ?-----------------------------------------------------------------

// Collection Cards To Load
const collectionCard = new Swiper(".collection-cards__wrapper", {
  slidesPerView: "auto",
  freeMode: true,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper_collection_card__next",
    prevEl: ".swiper_collection_card__prev",
  },
});

// Product Page Features; above Gallery Section
const productFeatureSwiper = new Swiper(".product-feature_swiper", {
  slidesPerView: 1,
  freeMode: true,
  loop: true,
  spaceBetween: 45,
  slidesPerView: "auto",
  navigation: {
    nextEl: ".ph-caret-right",
    prevEl: ".ph-caret-left",
  },
});

// Product Page Features; above Gallery Section
const productFeatureOverview = new Swiper(".article-container_main-features", {
  rewind: true,
  freeMode: true,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper_product-features__next",
    prevEl: ".swiper_product-features__prev",
  },

  pagination: {
    el: ".swiper_product-features-pagination",
  },

  breakpoints: {
    480: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
});

    const productBundleOptionSwiper = new Swiper('.product--bundle', {
    // Optional parameters
    loop: true,
      slidesPerView: 'auto',

        // Navigation arrows
  navigation: {
    nextEl: '.product--bundle .next',
    prevEl: '.product--bundle .prev',
  },

  });


// Testimonial (AUTO SCROLLING)
const testimonalSwiper = new Swiper('.testimonial__listing--autoscroll', {
              slidesPerView: "auto",
              spaceBetween: 15,
              loop: true,
              shortSwipes: false,
              longSwipes: false,
              allowTouchMove: false,
              autoplay: { delay: 1 },
              freeMode: false,
              speed: 10000,
});

